import { useApiQuery } from './api';
import type { FeatureFlags } from '../features/configuration/FeaturesSection';

const DEFAULT_FLAGS: FeatureFlags = {
  wizardRating: true,
  testMode: false,
  revealPartenaire: true,
  ticketsVisibility: 'admin_only',
  welcomeSms: 'off',
  storiesVisibility: 'off',
  financeVisibility: 'admin_only',
  financeLedger: false,
  reattributionDoorToDoor: false,
};

/**
 * React hook returning the current global FeatureFlags.
 *
 * Single source of truth for AppSetting-driven flags. Reads le endpoint
 * PUBLIC `/features` (`@AnyRole()` côté API) — PAS `/app-settings/features`
 * qui est admin-only et 403 pour tout autre rôle. La plupart des
 * consommateurs de ce hook (wizard, banner test) sont utilisés par des
 * vendeurs ; avant ce fix le hook retombait silencieusement sur
 * `DEFAULT_FLAGS` pour eux, sans jamais lire la config réelle. Query key
 * `['features']` alignée avec l'invalidation déjà faite par
 * `FeaturesSection` et l'appel direct de `RecapStep`.
 */
export function useFeatureFlags(): FeatureFlags {
  const q = useApiQuery<Partial<FeatureFlags>>(['features'], '/features');
  return { ...DEFAULT_FLAGS, ...(q.data ?? {}) };
}

// Le prédicat d'activation du Fil vit dans `@doorly/shared` (storiesEnabledFor),
// partagé avec la garde API : une seule règle, pas de miroir à maintenir.
export { storiesEnabledFor } from '@doorly/shared';
